import React from 'react';

import { formatUSDCurrency } from '../../helpers/format';

const ReviewLicenseSection = ({
  propertyIndex,
  feature,
  goToEdit,
  sectionIndex,
  editImg,
  applicationEditable,
  capitalizeFirstLetter,
}) => {
  return (
    <div key={'property' + propertyIndex}>
      <div className="item-detail general-detail">
        <h3>{capitalizeFirstLetter(feature.section)}</h3>
        <div className="license">
          <div className="detail-item full">
            <h6>Licenses</h6>
            {feature.value.licenses && feature.value.licenses.length > 0 ? (
              <div className="content-part">
                <table className="license-table">
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>State</th>
                      <th>Number</th>
                      <th>Expiration Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {feature.value.licenses?.map((license, index) => {
                      return (
                        <tr key={'license' + index}>
                          <td>{license.type}</td>
                          <td>{license.state}</td>
                          <td>{license.number}</td>
                          <td className="td-align-right">{license.expirationDate}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="empty-text">You do not have any license added</p>
            )}
          </div>
          <div className="detail-item insurances">
            <h6>Insurances</h6>
            {feature.value.insurances && feature.value.insurances.length > 0 ? (
              <div className="content-part">
                <table className="insurance-table">
                  <thead>
                    <tr>
                      <th>Insurance Provider</th>
                      <th>Policy Number</th>
                      <th className="amount">Coverage Amount</th>
                      <th>Expiration Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {feature.value.insurances?.map((insurance, index) => {
                      return (
                        <tr key={'insurance' + index}>
                          <td>{insurance.provider}</td>
                          <td>{insurance.policyNumber}</td>
                          <td className="amount">{formatUSDCurrency(insurance.coverageAmount)}</td>
                          <td className="td-align-right">{insurance.expirationDate}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="empty-text">You do not have any insurance added</p>
            )}
          </div>
        </div>
      </div>
      <div className="edit-action d-flex" onClick={() => goToEdit(sectionIndex, propertyIndex)}>
        {applicationEditable && (
          <>
            <img src={editImg} alt="" />
            <span>I have some edits!</span>
          </>
        )}
      </div>
    </div>
  );
};

export default ReviewLicenseSection;
